import {settleExistingSection} from '../../core/actionHighlighter';

/**
 * Open the WIDS/WIPS settings on the Canvas Settings Security tab.
 *
 * The tab is selected by navigating to `?tab=security`; it is settled here
 * as well because the route can arrive before the tab list has rendered.
 *
 * @return {Promise<object>} what the page reports it opened
 */
export async function openSecuritySection() {
	try {
		await settleExistingSection('Security');
		const seen = await settleExistingSection('WIDS/WIPS');
		return {...(seen || {}), section_id: 'settings.security'};
	} catch (_) {
		throw new Error('settings_security_unavailable');
	}
}
